import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

/**
 * スタイル統一ボックスプロパティ
 */
type StyledBoxProps = BoxProps;

/**
 * スタイル統一ボックス
 * @returns
 */
const StyledBox: React.FunctionComponent<StyledBoxProps> = (props) => (
  <Box
    borderColor="gray.300"
    borderRadius="md"
    borderWidth={1}
    padding={2}
    textAlign="left"
    {...props}
  />
);

export default StyledBox;
